import axios from 'axios'

const ENDPOINT = 'report'

export default {
    
  printQUnit: async (sitePath, pk, template) => {
    const epk = encodeURIComponent(pk)
    const url = `${sitePath}/${ENDPOINT}/${epk}/get_qunit_report/?template=${template}`
    const response = await axios.get(url, {responseType: 'arraybuffer'})
    return response
      
  },

  pdfQUnit: async (sitePath, pk, template) => {
    const epk = encodeURIComponent(pk)
    const url = `${sitePath}/${ENDPOINT}/${epk}/get_qunit_pdf/?template=${template}`
    const response = await axios.get(url, {responseType: 'arraybuffer'})
    return response
      
  },

  printQUnitCustomTemplate: async (sitePath, pk, template_file) => {
    const epk = encodeURIComponent(pk)
    let formData = new FormData()
    formData.append("template", template_file)

    const url = `${sitePath}/${ENDPOINT}/${epk}/get_qunit_custom_report/`
    // const response = await axios.get(url, { responseType: 'arraybuffer' })
    const response = await axios({
      method: 'post',
      url: url,
      data: formData,
      config: {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
      responseType: 'arraybuffer'
    })
    
    return response
  }
}
